import React, { useState, useEffect, useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Nav, Dropdown } from 'react-bootstrap';
import APIServicenew from "../../utils/APIGeneralService";
import { UserContext } from "../../context/UserContextProvider";
import { useNavigate } from "react-router-dom";

const Sidebar = ({ isOpen, setIsOpen }) => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 767) {
        setIsOpen(false);
      } else {
        setIsOpen(true);
      }
    };

    // Initial check
    handleResize();

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setIsOpen]);

  const [dropdownOpen, setDropdownOpen] = useState({});
  const [menuItems, setMenuItems] = useState([]);
  const [menuLoading, setMenuLoading] = useState(true);
  const location = useLocation();
  const { accessToken, setPermissionscontext, logout } = useContext(UserContext);

  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const headers = { "auth-token": authToken, authorization: accessToken };

  useEffect(() => {
    fetchMenuData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchMenuData = async () => {
    setMenuLoading(true);
    try {
      const response = await APIServices.get("/admin/get_side_menu", headers);
      if (response?.data?.status) {
        setMenuItems(response?.data?.data);
        setPermissionscontext(response?.data?.data);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        console.error("Error: ", response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching menu data:", error);
    } finally {
      setMenuLoading(false);
    }
  };

  const toggleCollapse = () => {
    setCollapseOpen(!collapseOpen);
  };

  const toggleDropdown = (menuItem) => {
    setDropdownOpen((prevState) => {
      const newState = {};
      // Close all dropdowns
      Object.keys(prevState).forEach((key) => {
        newState[key] = false;
      });
      // Toggle the clicked dropdown
      newState[menuItem] = !prevState[menuItem];

      return newState;
    });
  };

  // Filter function to check if menu should be shown
  const shouldShowMenu = (item) => {
    return item.is_hide === 0;
  };

  // Recursive function to filter menu items and their children
  const filterMenuItems = (items) => {
    return items
      .filter(item => shouldShowMenu(item))
      .map(item => {
        if (item.children && item.children.length > 0) {
          // Filter children as well
          const filteredChildren = item.children.filter(child => shouldShowMenu(child));
          return {
            ...item,
            children: filteredChildren
          };
        }
        return item;
      });
  };

  const createLinks = (items) => {
    // Filter items based on is_hide condition before rendering
    const filteredItems = filterMenuItems(items);
    
    return filteredItems.map((item, key) => {
      const hasChildren = item.children && Array.isArray(item.children) && item.children.length > 0;
      
      const isChildActive = hasChildren && item.children.some(
        child => location.pathname === child.url || location.pathname.startsWith(child.url + '/')
      );
      const isExactActive = !hasChildren && (
        location.pathname === item.url || location.pathname.startsWith(item.url + '/')
      );

      return (
        <Nav.Item key={key} className="sidebar-nav-item w-100">
          {hasChildren ? (
            <Dropdown className="Sidebar_drop" onToggle={() => toggleDropdown(item.name)}>
              <Dropdown.Toggle className={`text-white d-flex align-items-center w-100 ${isChildActive ? "active" : ""}`}>
                <img src={`/images/sidebar/${item.icon}`} className='img-fluid me-2' alt={item.name} />
                <div className="d-flex justify-content-between text">
                  {isOpen && item.name} {dropdownOpen[item.name] ? <FaChevronUp /> : <FaChevronDown />}
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {item.children.map((subItem, subKey) => (
                  <Dropdown.Item
                    as={NavLink}
                    to={subItem.url}
                    key={subKey}
                    className="sub-menu-link"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <p>{subItem.name}</p>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          ) : (
            <Nav.Link
              as={NavLink}
              to={item.url}
              className={`text-white d-flex align-items-center ${isExactActive ? "active" : ""}`}
            >
              <img src={`/images/sidebar/${item.icon}`} className='img-fluid me-2' alt={item.name} />
              {isOpen && item.name}
            </Nav.Link>
          )}
        </Nav.Item>
      );
    });
  };

  return (
    <div>
      <div className={`d-flex flex-column sidemenu ${isOpen ? "open" : "close"}`} style={{ transition: "0.3s" }}>
        <button className="btn btn-outline-light mb-3" onClick={() => setIsOpen(!isOpen)}>
          <img src="/images/white_larrow.svg" className='img-fluid' alt="toggle sidebar" />
        </button>
        <Nav className="flex-column">
          {menuLoading
            ? Array.from({ length: 6 }).map((_, i) => (
                <div key={i} style={{
                  height: 38, margin: "4px 8px", borderRadius: 6,
                  background: "rgba(255,255,255,0.12)",
                  animation: "sidebar-shimmer 1.4s ease-in-out infinite",
                  animationDelay: `${i * 0.1}s`
                }} />
              ))
            : createLinks(menuItems)
          }
        </Nav>
      </div>
    </div>
  );
};

export default Sidebar;